export default {
  row1: [
    {
      column: "column1",
      columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "importEntityType",
            label: "Type",
            component: "dropdown",
            width: "100%",
            endIconName: "LuChevronDown",
            defaultValue: "job1",
            options: [
              { label: "Customer", value: "Customer" },
              { label: "Transporter", value: "Transporter" },
              { label: "Forwarding Agent", value: "Forwarding Agent" },
            ],
            required: true,
          },
        ],
        row2: [
          {
            name: "importEntityName",
            label: "Name",
            component: "text-field",
            endIconName: "LuSearch",
            type: "autocomplete",
            width: "100%",
            endpoint: "getCustomers",
            required: true,
            autofillTargets: {
              importEntityAddress: "address",
              importEntityCountry: "country",
              importEntityState: "state",
              importEntityCity: "city",
              importEntityPostalCode: "pincode",
              address : "addressLine"
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row3: [
          {
            name: "importEntityCountry",
            label: "Country",
            component: "text-field",
            endIconName: "LuSearch",
            width: "100%",
            type: "autocomplete",
            endpoint: "getCountry",
            // linkedValue: "importEntityCountry",
          },
        ],
        row4: [
          {
            name: "importEntityState",
            label: "State/Province",
            component: "text-field",
            iconName: "Search",
            width: "100%",
            type: "autocomplete",
            endpoint: "getStateMaster",
            // linkedValue: "importEntityState",
            // useLinkedValue: "importEntityCountry",
          },
        ],
        row5: [
          {
            name: "importEntityContactPerson", // ✅ as-is
            label: "Contact Person",
            component: "text-field",
            iconName: "Search",
            width: "100%",
          },
        ],
        row6: [
          {
            name: "importEntityAddress",
            label: "Address",
            component: "dropdown",
            width: "100%",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            type: "autocomplete",
            autofillTargets: {
              address: "addressLine",
              importEntityCountry: "country",
              importEntityState: "state",
              importEntityCity: "city",
              importEntityPostalCode: "pincode",
            },
          },
        ],
        row7: [
          {
            name: "address", // ✅ lowercase (different from Address)
            component: "textarea",
            disabled: true,
            width: "100%",
            height: 120,
            defaultValue: "123 Dummy Street, Example City",
            py: 2,
          },
        ],
      },
    },
    {
      column: "colum2",
      columnWidth: "50%",
      rows: {
        row1: [
          {
            name: "importEntityCity",
            label: "City",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCityMaster",
            dependsOn: "importEntityState",
            width: "100%",
            // useLinkedValue: "importEntityState",
          },
        ],
        row2: [
          {
            name: "importEntityPostalCode",
            label: "Postal Code",
            component: "text-field",
            width: "100%",
          },
        ],
        row3: [
          {
            name: "importEntityTelephone",
            label: "Telephone",
            component: "text-field",
            width: "100%",
            regex: "^[0-9]{14}$",
            regexMessage: "Please enter a valid Telephone Number(eg:10degit)",
            maxLength: 10,
          },
        ],
        row4: [
          {
            name: "importEntityFax",
            label: "Fax",
            component: "text-field",
            width: "100%",
            type: "phone",
            regex: "^[0-9]{10}$",
            regexMessage: "Please enter a valid Fax number(eg:10degit)",
            maxLength: 10,
          },
        ],
        row5: [
          {
            name: "importEntityEmail",
            label: "Email",
            component: "text-field",
            width: "100%",
            regex: "^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$",
            regexMessage: "Please enter a valid email(eg:Tri@gmail.com)",
          },
        ],
        row6: [
          {
            name: "importEntityMobile",
            label: "Mobile",
            component: "text-field",
            type: "phone",
            width: "100%",
            regex: "^[0-9]{10}$",
            regexMessage: "Please enter a valid mobile number(eg:10degit)",
            maxLength: 10,
          },
        ],
      },
    },
  ],
};
